import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.pageLoad ? _c("div", {
    staticClass: "orderlist"
  }, [_c("a-card", [_c("a-form", {
    attrs: {
      layout: "inline"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.query();
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.erpContent")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("orderList.erpContentPl")
    },
    model: {
      value: _vm.queryParam.condition.orderKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "orderKeyword", $$v);
      },
      expression: "queryParam.condition.orderKeyword"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.productKeyword")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("orderList.productKeyword_placeholder")
    },
    model: {
      value: _vm.queryParam.condition.productKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "productKeyword", $$v);
      },
      expression: "queryParam.condition.productKeyword"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.expressStatus")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.expressStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "expressStatus", $$v);
      },
      expression: "queryParam.condition.expressStatus"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.expressStatus0")))]), _c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.expressStatus1")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.expressStatus2")))]), _c("a-select-option", {
    attrs: {
      value: "3"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.expressStatus3")))]), _c("a-select-option", {
    attrs: {
      value: "4"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.expressStatus4")))]), _c("a-select-option", {
    attrs: {
      value: "5"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.expressStatus5")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    staticClass: "middleClass",
    staticStyle: {
      height: "42px"
    },
    attrs: {
      label: _vm.$t("orderList.creatDate")
    }
  }, [_c("date-range", {
    ref: "orderDate",
    attrs: {
      allowClear: false,
      endDate: _vm.queryParam.condition.endOrderDate,
      startDate: _vm.queryParam.condition.startOrderDate
    },
    on: {
      change: _vm.changeOrderDate
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.erpTicketStatus")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.orderStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "orderStatus", $$v);
      },
      expression: "queryParam.condition.orderStatus"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus5")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus7")))]), _c("a-select-option", {
    attrs: {
      value: "3"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus9")))])], 1)], 1)], 1), _c("a-col", {
    staticStyle: {
      height: "46px"
    },
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.erpTransport")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.transportationIds,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "transportationIds", $$v);
      },
      expression: "queryParam.condition.transportationIds"
    }
  }, _vm._l(_vm.transportCompanySupportList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    staticStyle: {
      height: "46px"
    },
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    staticClass: "middleClass",
    attrs: {
      label: _vm.$t("orderList.ArriveDate")
    }
  }, [_c("date-range", {
    ref: "ArriveDate",
    on: {
      change: _vm.changeArriveDate
    }
  })], 1)], 1), _c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.advanced,
      expression: "advanced"
    }]
  }, [_c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.payId")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.payId,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "payId", $$v);
      },
      expression: "queryParam.condition.payId"
    }
  }, _vm._l(_vm.payMethodList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.expressNo")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: ""
    },
    model: {
      value: _vm.queryParam.condition.expressNo,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "expressNo", $$v);
      },
      expression: "queryParam.condition.expressNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.customerKeyword")
    }
  }, [_c("a-tooltip", {
    attrs: {
      placement: "topLeft"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("orderList.customerKeyword_placeholder2")) + " ")]), _c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("orderList.customerKeyword_placeholder2")
    },
    model: {
      value: _vm.queryParam.condition.customerKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "customerKeyword", $$v);
      },
      expression: "queryParam.condition.customerKeyword"
    }
  })], 2)], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.erpAmount")
    }
  }, [_c("a-input-group", {
    attrs: {
      compact: ""
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "42%",
      "text-align": "center"
    },
    attrs: {
      allowClear: "",
      min: 1
    },
    model: {
      value: _vm.queryParam.condition.startTotalAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "startTotalAmount", $$v);
      },
      expression: "queryParam.condition.startTotalAmount"
    }
  }), _c("a-input-number", {
    staticStyle: {
      width: "16%",
      "pointer-events": "none",
      backgroundColor: "#fff"
    },
    attrs: {
      placeholder: "~",
      disabled: ""
    }
  }), _c("a-input-number", {
    staticStyle: {
      width: "42%",
      "text-align": "center"
    },
    attrs: {
      allowClear: "",
      min: 1
    },
    model: {
      value: _vm.queryParam.condition.endTotalAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "endTotalAmount", $$v);
      },
      expression: "queryParam.condition.endTotalAmount"
    }
  })], 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.deliveryMethod")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.deliveryWays,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "deliveryWays", $$v);
      },
      expression: "queryParam.condition.deliveryWays"
    }
  }, _vm._l(_vm.deliveryMethodList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.ddz")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect"),
      mode: "multiple"
    },
    model: {
      value: _vm.queryParam.condition.sellerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "sellerCode", $$v);
      },
      expression: "queryParam.condition.sellerCode"
    }
  }, _vm._l(_vm.ddzList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1)], 1), _c("a-col", {
    staticStyle: {
      "text-align": "right",
      float: "right",
      "line-height": "40px"
    },
    attrs: {
      md: 6,
      sm: 18
    }
  }, [_c("span", {
    staticClass: "table-page-search-submitButtons"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.query();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.inquire2")) + " ")]), _c("a", {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      click: function click($event) {
        _vm.advanced = !_vm.advanced;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.advanced ? this.$t("publicuse.putaway") : this.$t("publicuse.unfold")) + " "), _c("a-icon", {
    attrs: {
      type: _vm.advanced ? "up" : "down"
    }
  })], 1)], 1)])], 1)], 1)], 1), _c("a-card", {
    staticClass: "listBtn",
    staticStyle: {
      "min-width": "1460px"
    }
  }, [_c("a-row", {
    attrs: {
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", [_c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      loading: _vm.syncLoading
    },
    on: {
      click: _vm.syncErpOrder
    }
  }, [_vm._v(_vm._s(_vm.$t("orderList.syncErpOrders")))]), _c("a-button", {
    attrs: {
      icon: "sync",
      loading: _vm.logisiticLoding
    },
    on: {
      click: function click($event) {
        _vm.selectedRowKeys.length == 0 ? _vm.$message.success(_vm.$t("orderList.noselectedRowKey2")) : _vm.refreshLogisitic();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("orderList.btnExpress")))])], 1)], 1), _c("a-table", {
    attrs: {
      "row-selection": {
        selectedRowKeys: _vm.selectedRowKeys,
        onChange: _vm.onSelectChange
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + total;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.total
      },
      id: "sorttableclass",
      rowKey: "id",
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.orderList
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "orderKeyword",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("div", [_c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/orderDetail2",
              query: {
                id: record.id
              }
            }
          }
        }, [_vm._v(_vm._s(record.orderNo))])], 1), record.orderIdNo ? _vm._l(record.orderIdNo, function (item, index) {
          return _c("div", [_c("router-link", {
            staticClass: "underline",
            attrs: {
              target: "_blank",
              to: {
                name: "orderDetail",
                query: {
                  id: item.id
                }
              }
            }
          }, [_vm._v(_vm._s(item.no))])], 1);
        }) : _vm._e(), record.isDeliveryOrder == 1 ? _c("div", [_c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("orderList.mainAgent")))])], 1) : _vm._e()], 2);
      }
    }, {
      key: "customer",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/customermanager/editcustomer2",
              query: {
                erpCustomerId: record.customerId
              }
            }
          }
        }, [_c("div", [_vm._v(_vm._s(record.erpCustomerName))])])], 1);
      }
    }, {
      key: "sellerName",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("div", [_vm._v(_vm._s(record.sellerName))]), _c("div", [record.pdfType === 0 ? _c("span", [_vm._v(" -- ")]) : record.pdfType === 1 ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("orderList.npsYes")) + " ")]) : record.pdfType === 2 ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("orderList.npsNo")) + " "), _c("span", {
          staticStyle: {
            "text-decoration": "underline",
            color: "#1890ff",
            cursor: "pointer",
            padding: "0"
          },
          attrs: {
            type: "link"
          },
          on: {
            click: function click($event) {
              return _vm.OnShowPdfDownloadUrl(record);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("orderList.shownps")) + " ")])]) : _vm._e()])]);
      }
    }, {
      key: "orderStatus",
      fn: function fn(text, record) {
        return _c("span", {}, [record.orderStatus ? _c("div", {
          staticClass: "orderStatus"
        }, [_vm._v(_vm._s(record.orderStatus == 1 ? _vm.$t("public.orderStatus5") : record.orderStatus == 2 ? _vm.$t("public.orderStatus7") : _vm.$t("public.orderStatus9")))]) : _vm._e(), _vm._v(" " + _vm._s(record.orderDate) + " ")]);
      }
    }, {
      key: "ColLang",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm.deliveryChannel == 1 ? _c("div", [_vm._v(_vm._s(record.deliveryChannelTitle))]) : _vm._e()]);
      }
    }, {
      key: "totalAmountTitle",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(_vm.$t("orderList.erpAmount2")) + " "), _c("div", [_vm._v(_vm._s(_vm.$t("orderList.ColPayTitle")))]), _c("div", [_vm._v(_vm._s(_vm.$t("orderList.cashOnDeliveryAmount")))])]);
      }
    }, {
      key: "totalAmount",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("div", [_vm._v(_vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm.toThousandslsFilter(record.totalAmount)) + _vm._s(_vm.rightCurrencySymbol + (record.taxList ? _vm.$t("orderList.suiru") : _vm.$t("orderList.suiba"))))]), _vm._v(" " + _vm._s(record.payTitle) + " "), record.isDeliveryOrder == 1 ? _c("div", [_vm._v(_vm._s(_vm.leftCurrencySymbol) + _vm._s(_vm.toThousandslsFilter(record.cashOnDeliveryAmount)) + _vm._s(_vm.rightCurrencySymbol + _vm.$t("orderList.suiru")))]) : _vm._e()]);
      }
    }, {
      key: "arriveDate",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("div", [_vm._v(_vm._s(record.arriveDate))])]);
      }
    }, {
      key: "customerNote",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            placement: "topLeft"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.customerNote) + " ")]), _vm._v(" " + _vm._s(record.customerNote) + " ")], 2)], 1);
      }
    }, {
      key: "orderTransportInfo",
      fn: function fn(text, record) {
        return _c("span", {}, _vm._l(record.orderTransportInfo, function (item, index) {
          return _c("dd", {
            key: index,
            staticClass: "colOrderTransportInfo"
          }, [_c("dl", [_vm._v(_vm._s(item.transportationName))]), _c("dl", {
            staticStyle: {
              flex: "2"
            }
          }, [_vm._v(_vm._s(item.expressNo))]), _c("dl", [_vm._v(_vm._s(item.expressNo ? _vm.$t("public.expressStatus".concat(item.expressStatus)) : _vm.$t("orderDetailTransport.noModeOfTransport2")))])]);
        }), 0);
      }
    }, {
      key: "orderServiceNote",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            placement: "topLeft"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.orderServiceNote) + " ")]), _vm._v(" " + _vm._s(record.orderServiceNote) + " ")], 2)], 1);
      }
    }, {
      key: "orderSource",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            placement: "topLeft"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.orderSource)), _c("br"), _vm._v(" " + _vm._s(record.userAgent) + " ")]), _c("div", {
          staticClass: "ellipsis"
        }, [_vm._v(_vm._s(record.orderSource))]), _vm._v(" " + _vm._s(record.userAgent) + " ")], 2)], 1);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a", {
          on: {
            click: function click($event) {
              return _vm.goDetail(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("orderList.details")))])]);
      }
    }], null, false, 3791367882)
  }, [_c("span", {
    attrs: {
      slot: "orderNoTitle"
    },
    slot: "orderNoTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("orderList.colERPNo")) + " "), _c("div", [_vm._v(_vm._s(_vm.$t("orderList.colOrderNo")))])]), _c("span", {
    attrs: {
      slot: "sellerNameTitle"
    },
    slot: "sellerNameTitle"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("orderList.ddz")))]), _c("div", [_vm._v(_vm._s(_vm.$t("orderList.npsshow")) + " ")])]), _c("span", {
    attrs: {
      slot: "orderStatusTitle"
    },
    slot: "orderStatusTitle"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("orderList.erpTicketStatus")))]), _vm._v(" " + _vm._s(_vm.$t("orderList.creatDate")) + " ")]), _c("span", {
    attrs: {
      slot: "ColLangTitle"
    },
    slot: "ColLangTitle"
  }, [_vm.deliveryChannel == 1 ? _c("div", [_vm._v(_vm._s(_vm.$t("orderList.ColChannelTitle")) + " ")]) : _vm._e()]), _c("span", {
    attrs: {
      slot: "arriveDateTitle"
    },
    slot: "arriveDateTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("orderList.ColArriveDate")) + " ")]), _c("span", {
    attrs: {
      slot: "orderSourceTitle"
    },
    slot: "orderSourceTitle"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("orderList.colOrderSource")))]), _vm._v(" " + _vm._s(_vm.$t("orderList.userAgent")) + " ")])])], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("orderList.editOrderTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      ok: _vm.orderStatustHandle
    },
    model: {
      value: _vm.orderStatustVisible,
      callback: function callback($$v) {
        _vm.orderStatustVisible = $$v;
      },
      expression: "orderStatustVisible"
    }
  }, [_c("a-form-model", {
    ref: "orderStatusRuleForm",
    attrs: {
      rules: _vm.orderStatusRules,
      model: _vm.orderStatusModalValue
    }
  }, [_c("a-alert", {
    attrs: {
      description: _vm.$t("orderList.tipsContent"),
      type: "warning",
      "show-icon": ""
    }
  }), _c("a-form-model-item", {
    attrs: {
      prop: "status"
    }
  }, [_c("a-tooltip", {
    attrs: {
      slot: "label",
      placement: "topRight"
    },
    slot: "label"
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    domProps: {
      innerHTML: _vm._s(_vm.$t("orderList.statusTipsContent"))
    },
    slot: "title"
  }), _vm._v(" " + _vm._s(_vm.$t("orderList.orderStatus")) + " "), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1), _c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.orderStatusModalValue.status,
      callback: function callback($$v) {
        _vm.$set(_vm.orderStatusModalValue, "status", $$v);
      },
      expression: "orderStatusModalValue.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus1")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus2")))]), _c("a-select-option", {
    attrs: {
      value: "3"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus3")))]), _c("a-select-option", {
    attrs: {
      value: "4"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus4")))]), _c("a-select-option", {
    attrs: {
      value: "5"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus5")))]), _c("a-select-option", {
    attrs: {
      value: "6"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus6")))]), _c("a-select-option", {
    attrs: {
      value: "8"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus8")))])], 1)], 1)], 1)], 1), _vm.orderSendDateVisible ? _c("a-modal", {
    attrs: {
      title: _vm.$t("orderList.editSendDateTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      ok: _vm.orderSendDateHandle
    },
    model: {
      value: _vm.orderSendDateVisible,
      callback: function callback($$v) {
        _vm.orderSendDateVisible = $$v;
      },
      expression: "orderSendDateVisible"
    }
  }, [_c("a-form-model", {
    ref: "orderSendDateRuleForm",
    attrs: {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 14
      },
      rules: _vm.orderSendDateRules,
      model: _vm.orderSendDateModalValue
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderList.btnPlanSendTime"),
      prop: "date"
    }
  }, [_c("a-date-picker", {
    attrs: {
      valueFormat: "YYYY-MM-DD"
    },
    model: {
      value: _vm.orderSendDateModalValue.date,
      callback: function callback($$v) {
        _vm.$set(_vm.orderSendDateModalValue, "date", $$v);
      },
      expression: "orderSendDateModalValue.date"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.orderNoteVisible ? _c("a-modal", {
    attrs: {
      title: _vm.$t("orderList.addOrderNoteTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      ok: _vm.orderNoteHandle
    },
    model: {
      value: _vm.orderNoteVisible,
      callback: function callback($$v) {
        _vm.orderNoteVisible = $$v;
      },
      expression: "orderNoteVisible"
    }
  }, [_c("a-form-model", {
    ref: "orderNoteRuleForm",
    attrs: {
      rules: _vm.orderNoteRules,
      model: _vm.orderNoteModalValue
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderList.orderNote"),
      prop: "note"
    }
  }, [_c("a-textarea", {
    attrs: {
      "auto-size": {
        minRows: 3,
        maxRows: 5
      }
    },
    model: {
      value: _vm.orderNoteModalValue.note,
      callback: function callback($$v) {
        _vm.$set(_vm.orderNoteModalValue, "note", $$v);
      },
      expression: "orderNoteModalValue.note"
    }
  })], 1)], 1)], 1) : _vm._e(), _c("a-modal", {
    attrs: {
      title: _vm.$t("public.tip"),
      visible: _vm.mergeVisible,
      footer: null
    },
    on: {
      cancel: function cancel() {
        return _vm.mergeVisible = false;
      }
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderList.mergeContent", {
    orderNo: _vm.mergeOrderNo
  })))]), _c("router-link", {
    attrs: {
      target: "_blank",
      to: "/orderDetail?id=" + _vm.mergeOrderid
    }
  }, [_vm._v(_vm._s(_vm.$t("public.lookData")))])], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };